import React, { useState } from "react";

// import Table from "./Table"
import TableSelection from "./TableSelection";
import BarchartSelection from "./BarchartSelection";

function FiltersResult({year, demographics, movement}) {
    const [button1Color, setButton1Color] = useState('white');
    const [button2Color, setButton2Color] = useState('white');
    const [selectedButton, setselectedButton] = useState("");

    const handleButton1Click = () => {
        setButton1Color('aqua');
        setButton2Color('white')
        setselectedButton("Button1");
      };
    
      const handleButton2Click = () => {
        setButton2Color('aqua');
        setButton1Color('white')
        setselectedButton("Button2");
      };

   

    

  return(
        <div>
            <div style = {{display: "flex"}}>
                <button type="button" className="btn btn-outline-secondary" style={{ backgroundColor: button1Color, marginRight: "5px"}} onClick={handleButton1Click} >
                    Ραβδόγραμμα
                </button>
                <button type="button" className="btn btn-outline-secondary" style={{ backgroundColor: button2Color }} onClick={handleButton2Click}>
                    Πίνακας Δεδομένων
                </button>    
            </div>
            <hr style = {{borderColor: "aqua"}}></hr>
            {selectedButton === ("Button2")? <TableSelection year = {year} demographics = {demographics} movement = {movement}/>: <BarchartSelection year = {year} demographics = {demographics} movement = {movement}/> }
        </div>
        
        
  );
}

export default FiltersResult;
